// src/hooks/useCrudData.js
import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../../config/useAxiosConfig";

const useDataHook = (source) => {
  const { loading: axiosLoading, error } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDataFromSource = async (url) => {
    try {
      setLoading(true);
      const response = await axios.get(url);
      setData(response.data?.rows || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!axiosLoading) {
      switch (source) {
        case "UserProfileRequest":
          fetchDataFromSource("/ArchiveChangeRequest");
          break;
        case "DropStudentsRequest":
          fetchDataFromSource("/ArchiveDropRequests");
          break;
        case "TestingRequest":
          fetchDataFromSource("/ArchiveTestingRequests");
          break;
        case "CourseProctorApp":
          fetchDataFromSource("/ArchiveCourseProctor");
          break;
        case "ChangeCourseRequests":
          fetchDataFromSource("/ChangeNewCourseRequestCollection");
          break;
        case "NewCourseRequests":
          fetchDataFromSource("/NewCourseNewRequestCollection");
          break;
        case "SchoolChangeForm": // New case for School Change Form
          fetchDataFromSource("/SchoolNewStudentChangeFormCollection");
          break;
        default:
          fetchDataFromSource("/defaultEndpoint"); // Replace with a default endpoint if needed
          break;
      }
    }
  }, [axiosLoading, source]);

  return { data, loading, error };
};

export default useDataHook;
